import { ApiClient } from '../../core/api/ApiClient';
import { RecommendationRepositoryImpl } from './implementations';
import { RecommendationService } from './services';

export * from './implementations';
export * from './interfaces';
export * from './services';

class RecommendationDomainContainer {
  constructor() {
    this._apiClient = null;
    this._recommendationRepository = null;
    this._recommendationService = null;
  }

  get apiClient() {
    if (!this._apiClient) {
      const baseURL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1';
      this._apiClient = new ApiClient(baseURL);
    }
    return this._apiClient;
  }

  get recommendationRepository() {
    if (!this._recommendationRepository) {
      this._recommendationRepository = new RecommendationRepositoryImpl(this.apiClient);
    }
    return this._recommendationRepository;
  }

  get recommendationService() {
    if (!this._recommendationService) {
      this._recommendationService = new RecommendationService(this.recommendationRepository);
    }
    return this._recommendationService;
  }

  reset() {
    this._apiClient = null;
    this._recommendationRepository = null;
    this._recommendationService = null;
  }
}

const container = new RecommendationDomainContainer();

export const getRecommendationService = () => container.recommendationService;
export const resetRecommendationContainer = () => container.reset();
